const getTelLinkFromPhone = phone => "tel:+55" + phone.replace(/[^0-9]/g, "");

const getWhatsappLinkFromPhone = phone =>
  "https://wa.me/55" + phone.replace(/[^0-9]/g, "");

/**
 * Obter código do vído do youtube por sua URL.
 *
 * @param {string} url
 */
const getYoutubeCode = url => {
  url = new URL(url);

  let code;
  switch (url.host) {
    case "www.youtube.com":
      code = url.searchParams.get("v");
      break;
    case "youtu.be":
      code = url.pathname.replace(/\/(.+)\/?.*/, "$1");
      break;
  }
  return code;
};

/**
 * Formatar string para URL.
 */
const formatToURL = str =>
  str
    .normalize("NFD")
    .replace(/\s+/g, "-")
    .replace(/([\u0300-\u036f]|[^0-9a-zA-Z-])/g, "")
    .toLocaleLowerCase();

/**
 * Agrupar array de objetos por propiedade do objeto.
 *
 * @param {array} items
 * @param {string} key
 */
const arrayGroupBy = (items, key) =>
  items.reduce(
    (result, item) => ({
      ...result,
      [item[key]]: [...(result[item[key]] || []), item]
    }),
    {}
  );

export {
  getTelLinkFromPhone,
  getWhatsappLinkFromPhone,
  getYoutubeCode,
  formatToURL,
  arrayGroupBy
};
